export const STAMPS_FRAGMENT = `
    stamps {
        commenced
        completed
    }
`